import React from 'react';
import { Clock, Users, FileText, Settings, Plus, TrendingUp } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';

const QuickActionTiles = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleQuickClockIn = async () => {
    try {
      // For now, just navigate to kiosk interface
      // In a real implementation, this would handle quick clock in
      navigate('/kiosk-clock-interface');
    } catch (err) {
      alert('Einstempeln fehlgeschlagen. Bitte erneut versuchen.');
      console.error('Clock in error:', err);
    }
  };

  const quickActions = [
    {
      id: 1,
      title: 'Ein-/Aus-stempeln',
      description: 'Schnelle Zeiterfassung',
      icon: Clock,
      color: 'bg-green-500',
      action: () => navigate('/kiosk-clock-interface')
    },
    {
      id: 3,
      title: 'Mitarbeiterverwaltung',
      description: 'Mitarbeiterdaten verwalten',
      icon: Users,
      color: 'bg-purple-500',
      action: () => navigate('/employee-management')
    },
    // {
    //   id: 4,
    //   title: 'Zeitberichte',
    //   description: 'Zeiteinträge anzeigen',
    //   icon: FileText,
    //   color: 'bg-orange-500',
    //   action: () => navigate('/audit-trail-review')
    // },
    {
      id: 5,
      title: 'Zeitkorrekturen',
      description: 'Korrekturen prüfen',
      icon: TrendingUp,
      color: 'bg-red-500',
      action: () => navigate('/time-entry-corrections')
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg">
      <div className="p-6">
        <h3 className="text-lg font-semibold text-text-primary mb-6">Schnellaktionen</h3>
        
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
          {quickActions?.map((action) => {
            const IconComponent = action?.icon;
            return (
              <button
                key={action?.id}
                onClick={action?.action}
                className="flex flex-col items-center p-4 rounded-lg border border-border hover:border-primary/50 hover:shadow-md transition-all duration-200 group touch-feedback"
              >
                <div className={`${action?.color} p-3 rounded-lg mb-3 group-hover:scale-110 transition-transform duration-200`}>
                  <IconComponent className="h-6 w-6 text-white" />
                </div>
                <h4 className="font-medium text-text-primary text-sm mb-1">{action?.title}</h4>
                <p className="text-xs text-text-secondary text-center">{action?.description}</p>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default QuickActionTiles;